import { render, staticRenderFns } from "./ioqdiv.vue?vue&type=template&id=58b098ce"
import script from "./ioqdiv.vue?vue&type=script&lang=js"
export * from "./ioqdiv.vue?vue&type=script&lang=js"
import style0 from "./ioqdiv.vue?vue&type=style&index=0&id=58b098ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports